import { useFeatureFlagVariantKey } from "posthog-js/react";

export function usePermissionsModalExperiment() {
	const variant = useFeatureFlagVariantKey("lp_permissions_modal") as
		| "control"
		| "show_modal";
	return {
		showModal: variant === "show_modal",
	};
}
